import * as React from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type ButtonProps = React.ComponentProps<typeof Button>;

interface IconButtonProps extends ButtonProps {
  /** Tooltip label shown on hover and used for aria-label */
  tooltip: string;
  /** Tooltip placement side (default: "top") */
  tooltipSide?: "top" | "bottom" | "left" | "right";
}

/**
 * An icon-only Button wrapped with an accessible Tooltip.
 * Automatically sets `size="icon"`, `aria-label`, and renders a tooltip on hover.
 */
const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ tooltip, tooltipSide = "top", children, ...buttonProps }, ref) => (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button ref={ref} size="icon" aria-label={tooltip} {...buttonProps}>
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent side={tooltipSide}>
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  )
);
IconButton.displayName = "IconButton";

export { IconButton };
export type { IconButtonProps };
